import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { pains } from '../data/offer';
export function PainSection() {
  return <section className="w-full bg-carbon-800 py-16 sm:py-20 lg:py-28" aria-labelledby="pain-heading" data-id="element-162" data-mp="38vkeocenfju7">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-163" data-mp="2yz7p9qq4zs59">
        <SectionHeading id="pain-heading" eyebrow="The real cost" title="Improvisation is the silent killer of your coaching business" subtitle="You show up to the track with a general idea — then an athlete asks “why is my knee hurting?” and there’s no concrete answer to give." data-id="element-164" data-mp="2z1tvnn1ak1lw" />

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:mt-14 sm:gap-6 md:grid-cols-3" data-id="element-165" data-mp="2g8zqfktgznuv">
          {pains.map(pain => <li key={pain.title} className="flex h-full flex-col rounded-xl border border-carbon-line bg-carbon-900 p-7" data-id="element-166" data-mp="22985t18g797w">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-mint/10" data-id="element-167" data-mp="3rn0uflzysw7p">
                <XIcon className="h-5 w-5 text-mint-deep" aria-hidden="true" data-id="element-168" data-mp="3nlfjw7awku0o" />
              </span>
              <h3 className="mt-6 font-display text-xl uppercase text-paper" data-id="element-169" data-mp="5fsrsrgfj3fd">{pain.title}</h3>
              <p className="mt-3 leading-relaxed text-paper-dim" data-id="element-170" data-mp="5dgbeiqbl14f">{pain.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}